<div class="mat-typography">
    <div class="mat-typography content">
        <p>AVG Data Load Duration: {{ zcStatistic?.avgDataLoadDurationMs | number : '.2-2' }} ms</p>
        <p>AVG Calculation Time: {{ zcStatistic?.avgCalculationTimeMs | number : '.2-2' }} ms</p>
        <p>AVG Save to DB Time: {{ zcStatistic?.avgSaveToDBTimeMs | number : '.2-2' }} ms</p>
        <p>AVG Service Calculation Time: {{ zcStatistic?.avgServiceCalculationTimeMs | number : '.2-2' }} ms</p>
        <p>AVG GIS Calculation Time: {{ (zcStatistic?.avgGISCalculationTimeMs ||
            zcStatistic?.avgServiceCalculationTimeMs - zcStatistic?.avgDataLoadDurationMs) | number : '.2-2' }} ms</p>
        <p>AVG Total Processing Time: {{ zcStatistic?.avgTotalProcessingTimeMs | number : '.2-2' }} ms</p>
    </div>
</div>
